module.exports = {"440224001":"丹霞街道","440224102":"闻韶镇","440224103":"扶溪镇","440224104":"长江镇","440224105":"城口镇","440224106":"红山镇","440224107":"石塘镇","440224108":"董塘镇","440224109":"大桥镇","440224110":"周田镇","440224111":"黄坑镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440224.json
// module id = 2086
// module chunks = 0